import _objectSpread from "D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { formatDate } from '@/utils';
import HeightSearchTpl from '@/components/Search/HeightSearchTpl';
import MyCascader from '@/components/MyCascader';
import { getBaseurl } from '@/utils/auth';
export default {
  components: {
    MyCascader: MyCascader,
    HeightSearchTpl: HeightSearchTpl
  },
  data: function data() {
    var _JSON$parse, _JSON$parse$COMBINEDS;
    var systemBaseUrl = getBaseurl();
    return {
      showHistory: false,
      showAssociate: true,
      showinstIssueNumAssociate: true,
      showtitlemAssociate: true,
      showSearchHeight: false,
      timer: false,
      // 用于延迟请求处理
      showstyle: '',
      options: [{
        label: '001',
        value: '类型1'
      }],
      historyData: [],
      associateData: [],
      instIssueNumassociateData: [],
      titleassociateData: [],
      scopeData: [],
      statusData: [],
      issueTypeData: [],
      showOrg: false,
      selectdOrgArr: [],
      defaultCheckedKeyArr: [],
      mouseIndex: -1,
      searchValue: '',
      isPrecise: true,
      systemList: ((_JSON$parse = JSON.parse(sessionStorage.getItem('dist_info'))) === null || _JSON$parse === void 0 ? void 0 : (_JSON$parse$COMBINEDS = _JSON$parse.COMBINEDSEARCH) === null || _JSON$parse$COMBINEDS === void 0 ? void 0 : _JSON$parse$COMBINEDS.LC_WEB) || [],
      activeName: '综合搜索',
      systemId: '',
      systemBaseUrl: systemBaseUrl,
      heightSearchObj: {
        LC_IE: {
          placeholder: '请输入搜索内容',
          searchFormData: {
            // 检索条件
            pageNum: 1,
            pageSize: 10,
            requestVO: {
              filterField: {
                issueNum: null,
                instTitle: null,
                issueType: [],
                publishDateEnd: formatDate(new Date()),
                publishDateStart: '1970-01-01',
                daterange: ['1970-01-01', formatDate(new Date())],
                publishOrg: [],
                status: ['VALID'],
                type: []
              },
              key: null,
              sortReq: {
                field: 'SCORE',
                // 字段,可用值:EFFECTIVE_DATE,PUBLISH_DATE,PUBLISH_ORG,SCORE,示例值(PUBLISH_ORG)
                order: 'DESC'
              },
              precise: false
            }
          },
          url: systemBaseUrl.LC_IE,
          path: '/searchResult'
        },
        LC_RI: {
          placeholder: '请输入搜索关键词',
          searchFormData: null,
          url: systemBaseUrl.LC_RI,
          path: '/'
        },
        LC_FAQ: {
          placeholder: '请输入关键词模糊搜索',
          searchFormData: null,
          url: systemBaseUrl.LC_FAQ,
          path: '/legalqa/qacouple'
        },
        LC_REGULATORY_TRENDS: {
          placeholder: '请输入关键词搜索监管动态',
          searchFormData: {
            // 检索条件
            pageNum: 1,
            pageSize: 10,
            requestVO: {
              filterField: {
                title: null,
                publishChannel: [],
                publishDateEnd: formatDate(new Date()),
                publishDateStart: '1970-01-01',
                daterange: ['1970-01-01', formatDate(new Date())],
                publishOrgId: [],
                type: []
              },
              key: null,
              sortReq: {
                field: 'SCORE',
                // 字段,可用值:EFFECTIVE_DATE,PUBLISH_DATE,PUBLISH_ORG,SCORE,示例值(PUBLISH_ORG)
                order: 'DESC'
              },
              precise: false
            }
          },
          url: systemBaseUrl.LC_REGULATORY_TRENDS,
          path: '/'
        },
        LC_PUNISH: {
          placeholder: '请输入关键词搜索被处罚对象',
          searchFormData: {
            // 检索条件
            pageNum: 1,
            pageSize: 10,
            requestVO: {
              filterField: {
                title: '',
                documentNo: '',
                // 发文案号
                punishmentObject: '',
                // 被处罚对象
                punishOrganCategory: [],
                // 处罚机关类型
                cityIds: [],
                // 执法地域
                provinces: [],
                // 省份
                publishDateEnd: formatDate(new Date()),
                publishDateStart: '1970-01-01',
                daterange: ['1970-01-01', formatDate(new Date())],
                publishOrgId: [],
                regTitle: '' // 处罚案由依据
              },

              key: null,
              sortReq: {
                field: 'SCORE',
                // 字段,可用值:EFFECTIVE_DATE,PUBLISH_DATE,PUBLISH_ORG,SCORE,示例值(PUBLISH_ORG)
                order: 'DESC'
              },
              precise: false,
              isPrecise: false
            }
          },
          url: systemBaseUrl.LC_PUNISH,
          path: '/'
        },
        LCC: {
          placeholder: '请输入关键词搜索合同',
          searchFormData: {
            // 检索条件
            pageNum: 1,
            pageSize: 10,
            requestVO: {
              isPrecise: false,
              keyWord: null,
              orderBy: 'RELATED',
              orderDescending: 'DESC',
              searchFields: {
                businessType2: [],
                contractTitle: '',
                instIssueNum: '',
                instTitle: '',
                publishOrg2: [],
                effectRange: [],
                expireRange: [],
                status: []
              }
            }
          },
          url: systemBaseUrl.LCC,
          path: '/agreement/contractList'
        }
      },
      publishChannelList: [],
      publishOrgList: [],
      businessTypeOptions: [],
      showTitlemAssociateRegulator: false,
      systemInner: JSON.parse(sessionStorage.getItem('systemInner')),
      showIcon: false
    };
  },
  props: {
    selectSys: {
      type: String,
      default: ''
    },
    searchTitle: {
      type: String,
      default: ''
    }
  },
  mounted: function mounted() {
    var _this2 = this;
    window.addEventListener('message', function (e) {
      // const data = JSON.parse(e.data);
      var data = typeof e.data === 'string' ? JSON.parse(e.data) : e.data;
      if (data.type === 'HEIGHTSEARCHHEIGHT') {
        // this.$refs.iframe.height = data.data.height
      }
      if (data.type === 'HEIGHTSEARCH') {
        //
        _this2.showSearchHeightFn(false);
        var dataObj = JSON.parse(data.data.searchFormData);
        dataObj.requestVO.precise = _this2.isPrecise;
        window.open(decodeURIComponent("".concat(window.location.origin, "/?newPage=").concat(_this2.systemBaseUrl[data.data.systemId], "?searchFormData=").concat(JSON.stringify(dataObj))));
      }
    }, false);
    this.isPrecise = this.$route.query.isPrecise == '1';
    if (this.selectSys) {
      this.activeName = this.systemList[this.selectSys];
    }
    var _this = this;
    // eslint-disable-next-line no-unused-expressions
    document.addEventListener('click', function (e) {
      if (!_this2.$el.contains(e.target) || e.target.className === 'search-button' || e.target.className === 'search-height') {
        _this2.showHistoryFn(false);
        _this2.showAssociateFn(false);
      } else if (e.target.className === 'search-input') {
        if (!_this.searchValue) {
          _this2.showHistoryFn(true);
          _this2.showAssociateFn(false);
          _this2.showSearchHeightFn(false);
        } else {
          _this2.showAssociateFn(true);
          _this2.showHistoryFn(false);
          _this2.showSearchHeightFn(false);
        }
      }
      var arr = e.path;
      var bool = _this2.getClickPosition(arr);
      if (!_this2.$el.contains(e.target) && !bool && e.target.className && e.target.className !== 'btn btn-red' && e.target.className !== 'search-btn btn btn-red search-btn' && e.target.className !== 'el-button el-button--primary el-button--mini') {
        _this2.showSearchHeightFn(false);
      }
    });
    this.getHistroyFn();
    this.getSearchCondition();
    this.getRelatoryTrends();
    this.getPunishOrg();
    this.getListBusinessType();
  },
  methods: {
    getPunishOrg: function getPunishOrg() {
      var _this3 = this;
      this.$API.getRequest({
        url: '/punish/administrativePunish/getPunishOrgan'
      }).then(function (res) {
        if (res.code === 200 || res.code === '0000000000') {
          _this3.publishOrgList = res.result;
        } else {
          // this.$message({
          //   message:res.message,
          //   type:'warning'
          // })
        }
      });
    },
    getRelatoryTrends: function getRelatoryTrends() {
      var _this4 = this;
      this.$API.getRequest({
        url: '/rt/regulatoryTrends/getPublishOrg'
      }).then(function (res) {
        if (res.code === '0000000000') {
          res.result.forEach(function (ele) {
            _this4.publishChannelList.push({
              publishOrgId: ele.publishOrgId,
              publishOrgName: ele.publishOrgName
            });
          });
        } else {
          /* empty */
        }
      });
    },
    getSearchCondition: function getSearchCondition() {
      var _this5 = this;
      // 高级搜索条件获取
      this.$API.getRequest({
        url: 'ie/search'
      }).then(function (res) {
        if (res.code === '200') {
          _this5.issueTypeData = res.result.issueType;
          _this5.scopeData = res.result.scope;
          _this5.statusData = res.result.status;
        }
      }).catch(function () {});
    },
    setPublishDate: function setPublishDate() {
      // this.$store.commit('search/increment', {arr: this.searchFormData.requestVO.filterField.daterange})
      // this.$store.store.commit('increment')
      // let arr = [];
      // if (this.heightSearchObj[this.systemId].searchFormData.requestVO.filterField.daterange) {
      // const start = this.getDateTime(this.heightSearchObj[this.systemId].searchFormData.requestVO.filterField.daterange[0]);
      // const end = this.getDateTime(this.heightSearchObj[this.systemId].searchFormData.requestVO.filterField.daterange[1]);
      // arr = [start, end];
      // }
    },
    heightSearch: function heightSearch(systemId) {
      this.showSearchHeightFn(false);
      var path = '';
      // this.requestVO.precise = true
      //
      if (systemId === 'LC_IE') {
        this.searchValue = this.searchForm.requestVO.key;
        // this.searchForm.requestVO.key = this.heightSearchObj[systemId].searchFormData.requestVO.key = this.heightSearchObj[systemId].searchFormData.requestVO.key || this.searchValue;
      }
      // eslint-disable-next-line no-unused-expressions
      this.heightSearchObj[systemId].searchFormData ? this.heightSearchObj[systemId].searchFormData.requestVO.precise = this.isPrecise : '';
      this.heightSearchObj[systemId].searchFormData ? this.heightSearchObj[systemId].searchFormData.requestVO.isPrecise = this.isPrecise : '';
      this.searchForm.requestVO.precise = this.isPrecise;
      if (systemId === 'LC_REGULATORY_TRENDS' || systemId === 'LC_PUNISH' || systemId === 'LCC') {
        this.heightSearchObj[systemId].searchFormData.requestVO.key = this.searchValue;
        path = "".concat(this.heightSearchObj[systemId].path, "?searchFormData=").concat(JSON.stringify(this.heightSearchObj[systemId].searchFormData), "&isHash=1");
      } else if (systemId === 'LC_FAQ') {
        path = "".concat(this.heightSearchObj[systemId].path, "?keyword=").concat(this.searchValue, "&isChecked=").concat(isPrecise, "&isHash=1");
      } else if (systemId === 'LC_RMS') {
        path = "".concat(this.heightSearchObj[systemId].path, "?value=").concat(this.searchValue);
      } else if (systemId === 'LC_IE') {
        path = "".concat(this.heightSearchObj[systemId].path, "?searchFormData=").concat(JSON.stringify(this.searchForm), "&isHash=1");
      }
      var url = '';
      this.systemInner.forEach(function (ele) {
        if (ele && ele.systemId === systemId) {
          url = ele.baseUrl;
        }
      });
      window.open(decodeURIComponent("".concat(window.location.origin, "/?newPage=").concat(url, "&menuPath=").concat(path)));
    },
    resetForm: function resetForm() {
      var that = this;
      this.heightSearchObj = {
        LC_IE: {
          placeholder: '请输入搜索内容',
          searchFormData: {
            // 检索条件
            pageNum: 1,
            pageSize: 10,
            requestVO: {
              filterField: {
                issueNum: null,
                instTitle: null,
                issueType: [],
                publishDateEnd: formatDate(new Date()),
                publishDateStart: '1970-01-01',
                daterange: ['1970-01-01', formatDate(new Date())],
                publishOrg: [],
                status: ['VALID'],
                type: []
              },
              key: null,
              sortReq: {
                field: 'SCORE',
                // 字段,可用值:EFFECTIVE_DATE,PUBLISH_DATE,PUBLISH_ORG,SCORE,示例值(PUBLISH_ORG)
                order: 'DESC'
              },
              precise: false
            }
          },
          url: that.systemBaseUrl.LC_IE,
          path: '/searchResult'
        },
        LC_RI: {
          placeholder: '请输入搜索关键词',
          searchFormData: null,
          url: that.systemBaseUrl.LC_RI,
          path: '/'
        },
        LC_FAQ: {
          placeholder: '请输入关键词模糊搜索',
          searchFormData: null,
          url: that.systemBaseUrl.LC_FAQ,
          path: '/legalqa/qacouple'
        },
        LC_REGULATORY_TRENDS: {
          placeholder: '请输入关键词搜索监管动态',
          searchFormData: {
            // 检索条件
            pageNum: 1,
            pageSize: 10,
            requestVO: {
              filterField: {
                title: null,
                publishChannel: [],
                publishDateEnd: formatDate(new Date()),
                publishDateStart: '1970-01-01',
                daterange: ['1970-01-01', formatDate(new Date())],
                publishOrgId: [],
                type: []
              },
              key: null,
              sortReq: {
                field: 'SCORE',
                // 字段,可用值:EFFECTIVE_DATE,PUBLISH_DATE,PUBLISH_ORG,SCORE,示例值(PUBLISH_ORG)
                order: 'DESC'
              },
              precise: false
            }
          },
          url: that.systemBaseUrl.LC_REGULATORY_TRENDS,
          path: '/'
        },
        LC_PUNISH: {
          placeholder: '请输入关键词搜索被处罚对象',
          searchFormData: {
            // 检索条件
            pageNum: 1,
            pageSize: 10,
            requestVO: {
              filterField: {
                title: '',
                documentNo: '',
                // 发文案号
                punishmentObject: '',
                // 被处罚对象
                punishOrganCategory: [],
                // 处罚机关类型
                cityIds: [],
                // 执法地域
                provinces: [],
                // 省份
                publishDateEnd: formatDate(new Date()),
                publishDateStart: '1970-01-01',
                daterange: ['1970-01-01', formatDate(new Date())],
                publishOrgId: []
              },
              key: null,
              sortReq: {
                field: 'SCORE',
                // 字段,可用值:EFFECTIVE_DATE,PUBLISH_DATE,PUBLISH_ORG,SCORE,示例值(PUBLISH_ORG)
                order: 'DESC'
              },
              isPrecise: false,
              orderTime: 'DESC'
            }
          },
          url: that.systemBaseUrl.LC_PUNISH,
          path: '/'
        },
        LCC: {
          placeholder: '请输入关键词搜索合同',
          searchFormData: {
            // 检索条件
            pageNum: 1,
            pageSize: 10,
            requestVO: {
              isPrecise: false,
              keyWord: null,
              orderBy: 'RELATED',
              orderDescending: 'DESC',
              searchFields: {
                businessType2: [],
                contractTitle: '',
                instIssueNum: '',
                instTitle: '',
                publishOrg2: [],
                effectRange: [],
                expireRange: [],
                status: []
              }
            }
          },
          url: that.systemBaseUrl.LCC,
          path: '/agreement/contractList'
        }
      };
    },
    gettitleAssociateData: function gettitleAssociateData() {
      var _this6 = this;
      this.titleassociateData = [];
      if (this.systemId === 'LC_IE' || this.systemId === 'LCC') {
        var keyWord;
        if (this.systemId === 'LCC') {
          keyWord = this.heightSearchObj[this.systemId].searchFormData.requestVO.searchFields.instTitle.trim();
        } else {
          keyWord = this.heightSearchObj[this.systemId].searchFormData.requestVO.filterField.instTitle.trim();
        }
        this.$API.postRequest({
          url: '/ie/search/suggest',
          data: {
            keyWord: keyWord,
            limit: 5,
            type: 'INST_TITLE'
          }
        }).then(function (res) {
          _this6.titleassociateData = res.result;
        });
      } else if (this.systemId === 'LC_REGULATORY_TRENDS') {
        this.$API.postRequest({
          url: '/rt/search/suggest',
          data: {
            searchKey: this.heightSearchObj[this.systemId].searchFormData.requestVO.filterField.title.trim(),
            pageNum: 1,
            pageSize: 5
          }
        }).then(function (res) {
          _this6.titleassociateData = res.result;
        });
      }
    },
    instIssueNumFocus: function instIssueNumFocus() {
      var issueNum;
      if (this.systemId === 'LCC') {
        issueNum = this.heightSearchObj[this.systemId].searchFormData.requestVO.searchFields.instIssueNum;
      } else {
        issueNum = this.heightSearchObj[this.systemId].searchFormData.requestVO.filterField.issueNum;
      }
      if (issueNum) {
        // key值存在启用联想
        this.showinstIssueNumAssociate = true;
        this.getIssueAssociateData();
      } else {
        // 显示历史记录
        this.showinstIssueNumAssociate = false;
      }
    },
    instIssueNumChange: function instIssueNumChange() {
      var issueNum;
      if (this.systemId === 'LCC') {
        issueNum = this.heightSearchObj[this.systemId].searchFormData.requestVO.searchFields.instIssueNum;
      } else {
        issueNum = this.heightSearchObj[this.systemId].searchFormData.requestVO.filterField.issueNum;
      }
      if (issueNum && issueNum.length > 0) {
        // 联想搜索
        this.getIssueAssociateData();
        this.showinstIssueNumAssociate = true;
      } else {
        this.showinstIssueNumAssociate = false;
      }
    },
    titlemFocus: function titlemFocus() {
      var instTitle;
      if (this.systemId === 'LCC') {
        instTitle = this.heightSearchObj[this.systemId].searchFormData.requestVO.searchFields.instTitle;
      } else {
        instTitle = this.heightSearchObj[this.systemId].searchFormData.requestVO.filterField.instTitle;
      }
      if (instTitle) {
        // key值存在启用联想
        this.showtitlemAssociate = true;
        this.gettitleAssociateData();
      } else {
        // 显示历史记录
        if (this.systemId === 'LC_IE') {
          this.showtitlemAssociate = false;
        } else {
          this.showTitlemAssociateRegulator = false;
        }
      }
    },
    titleChange: function titleChange() {
      var instTitle;
      var title;
      if (this.systemId === 'LCC') {
        instTitle = this.heightSearchObj[this.systemId].searchFormData.requestVO.searchFields.instTitle;
        title = '';
      } else {
        instTitle = this.heightSearchObj[this.systemId].searchFormData.requestVO.filterField.instTitle;
        title = this.heightSearchObj[this.systemId].searchFormData.requestVO.filterField.title;
      }
      if (instTitle && instTitle.length > 0 || title && title.length > 0) {
        // 联想搜索
        this.gettitleAssociateData();
        if (this.systemId === 'LC_IE' || this.systemId === 'LCC') {
          this.showtitlemAssociate = true;
        } else {
          this.showTitlemAssociateRegulator = true;
        }
      } else {
        if (this.systemId === 'LC_REGULATORY_TRENDS') {
          this.showtitlemAssociate = false;
        } else {
          this.showTitlemAssociateRegulator = false;
        }
      }
    },
    chooceinstIssueNumAssicuate: function chooceinstIssueNumAssicuate(val) {
      this.heightSearchObj[this.systemId].searchFormData.requestVO.filterField.issueNum = val;
      this.showinstIssueNumAssociate = false;
    },
    choocetitleAssicuate: function choocetitleAssicuate(val) {
      if (this.systemId === 'LC_IE') {
        this.heightSearchObj[this.systemId].searchFormData.requestVO.filterField.instTitle = val;
        this.showtitlemAssociate = false;
      } else if (this.systemId === 'LCC') {
        this.heightSearchObj[this.systemId].searchFormData.requestVO.searchFields.instTitle = val;
        this.showtitlemAssociate = false;
      } else {
        this.heightSearchObj[this.systemId].searchFormData.requestVO.filterField.title = val;
        this.showTitlemAssociateRegulator = false;
      }
    },
    changeSys: function changeSys(item) {
      this.showHistoryFn(false);
      if (item === '') {
        this.activeName = '综合搜索';
        this.systemId = '';
      } else {
        this.systemId = item;
        this.activeName = this.systemList[item];
      }
    },
    choseSys: function choseSys(item) {
      this.showHistoryFn(false);
      if (item === '') {
        this.activeName = '综合搜索';
        this.systemId = '';
      } else {
        this.systemId = item;
        this.activeName = this.systemList[item];
      }
    },
    itemmouseOver: function itemmouseOver(i) {
      this.mouseIndex = i;
    },
    itemmouseLeave: function itemmouseLeave() {
      this.mouseIndex = -1;
    },
    getClickPosition: function getClickPosition(arr) {
      // 是的点击空白处
      var bool = false;
      if (arr && arr.length > 0) {
        for (var i = 0; i < arr.length; i++) {
          if (arr[i].nodeName === 'BODY') {
            break;
          }
          if (arr[i].className && arr[i].className.indexOf('dialog') > -1) {
            bool = true;
            break;
          }
        }
      }
      return bool;
    },
    /* 获取焦点事件 */searchFocus: function searchFocus() {
      if (this.searchValue) {
        // key值存在启用联想
        this.showHistoryFn(false);
        this.showAssociateFn(true);
        this.getAssociateData();
      } else {
        // 显示历史记录
        this.showHistoryFn(true);
        this.showAssociateFn(false);
        this.showSearchHeightFn(false);
        this.getHistroyFn();
      }
    },
    searchBlur: function searchBlur() {
      this.showHistoryFn(false);
    },
    chooceHistory: function chooceHistory(val) {
      this.searchValue = val;
      this.showHistoryFn(false);
      this.searchClick();
    },
    searchChange: function searchChange() {
      if (this.searchValue && this.searchValue.length > 0) {
        // 联想搜索
        this.getAssociateData();
        this.showHistoryFn(false);
        this.showAssociateFn(true);
      } else {
        this.showHistoryFn(true);
        this.showAssociateFn(false);
      }
      // if(this.requestVO.key) {
      // this.showHistoryFn(false)
      // this.showAssociateFn(true)
      // }
    },
    getAssociateData: function getAssociateData() {
      var _this7 = this;
      var list = [];
      // eslint-disable-next-line guard-for-in
      for (var key in this.systemList) {
        list.push(key);
      }
      if (this.systemId === 'LCC') {
        this.$API.postRequest({
          url: '/contract/search/suggest',
          data: {
            pageNum: 1,
            pageSize: 10,
            totalCount: 10,
            requestVO: {
              keyWord: this.searchValue,
              limit: 10,
              type: 'CONTRACT_TITLE'
            }
          }
        }).then(function (res) {
          if (['SUC000000', '0000000'].includes(res.code)) {
            _this7.associateData = (res.result || []).map(function (item) {
              return _objectSpread(_objectSpread({}, item), {}, {
                systemId: 'LCC'
              });
            });
          } else {
            _this7.$message({
              message: res.message,
              type: 'warning'
            });
          }
        });
      } else if (this.systemId === '') {
        this.$API.postRequest({
          url: '/platform/superSearch/suggest',
          data: {
            keyWord: this.searchValue,
            limit: 10,
            systemIdList: list
          }
        }).then(function (res) {
          if (res.code === '0000000000') {
            _this7.associateData = res.result;
          }
        });
      } else {
        this.$API.postRequest({
          url: '/platform/superSearch/suggestProxy',
          data: {
            keyWord: this.searchValue,
            limit: 10,
            systemId: this.systemId
          }
        }).then(function (res) {
          if (res.code === '0000000000') {
            _this7.associateData = res.result;
          }
        });
      }
    },
    /* 获取搜索的历史记录 */getHistroyFn: function getHistroyFn() {
      var _this8 = this;
      // this.$API.getRequest({url: '/ie/search/history', data: {limit: 10}}).then((res)=>{
      //   this.historyData = res.result
      // })
      if (this.systemId === 'LCC') {
        return this.$API.getRequest({
          url: '/contract/info/searchHistory'
        }).then(function (res) {
          if (['SUC000000', '0000000'].includes(res.code)) {
            _this8.historyData = (res.result || []).map(function (item) {
              return {
                keyWord: item
              };
            });
          } else {
            _this8.$message({
              message: res.message,
              type: 'warning'
            });
          }
        });
      } else if (this.systemId !== '') {
        this.$API.getRequest({
          url: '/platform/superSearch/historyProxy',
          data: {
            pageNum: 1,
            pageSize: 10,
            systemId: this.systemId
          }
        }).then(function (res) {
          _this8.historyData = res.result.records;
        });
      }
    },
    delHistory: function delHistory(val) {
      var _this9 = this;
      if (this.systemId === 'LCC') {
        this.$API.getRequest({
          url: '/contract/info/deleteSearchHistory',
          data: {
            searchKey: val
          }
        }).then(function (res) {
          if (['SUC000000', '0000000'].includes(res.code)) {
            _this9.historyData = _this9.historyData.filter(function (item) {
              return item.keyWord !== val;
            });
          }
        });
      } else {
        this.$API.delRequest({
          url: '/platform/superSearch/deleteHistory',
          data: {
            keyWord: val
          }
        }).then(function (res) {
          if (res.code === '0000000000') {
            _this9.historyData = _this9.historyData.filter(function (item) {
              return item.keyWord !== val;
            });
          }
        });
      }
    },
    showHistoryFn: function showHistoryFn(bool) {
      this.showHistory = bool;
    },
    showAssociateFn: function showAssociateFn(bool) {
      this.showAssociate = bool;
    },
    showSearchHeightFn: function showSearchHeightFn(bool) {
      this.showSearchHeight = bool;
      if (!bool) {
        // this.searchFormData.requestVO.filterField.issueNum = "";
        // this.instIssueNumassociateData = [];
        // this.searchFormData.requestVO.filterField.instTitle = "";
        // this.titleassociateData = [];
      }
    },
    chooceAssicuate: function chooceAssicuate(val, systemId) {
      // this.requestVO.key = val

      this.searchValue = val;
      this.showAssociateFn(false);
      this.changeSys(systemId);
      this.searchClick();
    },
    searchClick: function searchClick(string, id) {
      var systemId = this.systemId;
      var isPrecise = this.isPrecise;
      this.showHistoryFn(false);
      this.showAssociateFn(false);
      this.showSearchHeightFn(false);
      var path = '';
      if (string === 'getMore' && systemId === '') {
        // eslint-disable-next-line guard-for-in
        for (var key in this.systemList) {
          systemId = key;
          break;
        }
        if (id) {
          systemId = id;
        }
      }
      if (systemId === '') {
        this.$emit('searchCommon', this.searchValue, this.systemId);
      } else {
        // eslint-disable-next-line no-unused-expressions
        this.heightSearchObj[systemId].searchFormData ? this.heightSearchObj[systemId].searchFormData.requestVO.key = this.searchValue : '';
        // eslint-disable-next-line no-unused-expressions
        this.heightSearchObj[systemId].searchFormData ? this.heightSearchObj[systemId].searchFormData.requestVO.precise = isPrecise : '';
        // eslint-disable-next-line no-unused-expressions
        this.heightSearchObj[systemId].searchFormData ? this.heightSearchObj[systemId].searchFormData.requestVO.isPrecise = isPrecise : '';
        this.searchForm.requestVO.precise = isPrecise;
        if (systemId === 'LC_REGULATORY_TRENDS' || systemId === 'LC_PUNISH' || systemId === 'LCC') {
          path = "".concat(this.heightSearchObj[systemId].path, "?searchFormData=").concat(JSON.stringify(this.heightSearchObj[systemId].searchFormData), "&isHash=1");
        } else if (systemId === 'LC_FAQ') {
          path = "".concat(this.heightSearchObj[systemId].path, "?keyword=").concat(this.searchValue, "&isChecked=").concat(this.isPrecise, "&isHash=1");
        } else if (systemId === 'LC_RI') {
          path = "".concat(this.heightSearchObj[systemId].path, "?key=").concat(this.searchValue, "&precise=").concat(this.isPrecise);
        } else if (systemId === 'LC_IE') {
          this.searchForm.requestVO.key = this.heightSearchObj[systemId].searchFormData.requestVO.key = this.heightSearchObj[systemId].searchFormData.requestVO.key || this.searchValue;
          path = "".concat(this.heightSearchObj[systemId].path, "?searchFormData=").concat(JSON.stringify(this.searchForm), "&isHash=1");
        }
        var url = '';
        this.systemInner.forEach(function (ele) {
          if (ele && ele.systemId === systemId) {
            url = ele.baseUrl;
          }
        });
        // 如果path第一个字符是/，则去掉
        // if (path && path[0] === '/') {
        //   path = path.slice(1);
        // }
        window.open(decodeURIComponent("".concat(window.location.origin, "/?newPage=").concat(url, "&menuPath=").concat(path)));
      }
    },
    mouseOver: function mouseOver() {
      this.showstyle = 'color: #C9C9C9;';
    },
    // 移出
    mouseLeave: function mouseLeave() {
      this.showstyle = 'color: #fff;';
    },
    closeClick: function closeClick() {
      this.searchValue = null;
    },
    showOrgDialog: function showOrgDialog() {
      this.showOrg = true;
    },
    getListBusinessType: function getListBusinessType() {
      var _this10 = this;
      this.$API.getRequest({
        url: '/contract/info/listBusinessType'
      }).then(function (res) {
        if (['SUC000000', '0000000', '0000000000'].includes(res.code)) {
          _this10.businessTypeOptions = res.result || [];
          _this10.disposeBusinessTypeOptionsLeaf(_this10.businessTypeOptions);
        }
      });
    },
    // 处理合同业务分类，子叶节点标识
    disposeBusinessTypeOptionsLeaf: function disposeBusinessTypeOptionsLeaf(businessTypeOptions) {
      var _this11 = this;
      Array.isArray(businessTypeOptions) && businessTypeOptions.forEach(function (item) {
        var _item$children;
        _this11.disposeBusinessTypeOptionsLeaf(item.children);
        if ((_item$children = item.children) !== null && _item$children !== void 0 && _item$children.length) {
          item.leaf = false;
        } else {
          item.leaf = true;
          item.children = null;
        }
      });
    }
  },
  computed: {
    searchForm: function searchForm() {
      return this.$store.state.search.searchForm;
    }
  },
  watch: {
    searchTitle: {
      handler: function handler(N) {
        this.searchValue = N;
      }
    }
  }
};